import { atom, useAtom } from "jotai";
import { useCallback, useEffect } from "react";
import { getUser } from "..";
import { useLoginToken } from "../../hooks";
import type { ShellUser } from "../types";

type UpdateUserFunction = (
  requestOption?: RequestInit
) => Promise<ShellUser | null>;

const userAtom = atom<ShellUser | null>(null);

export const useUser = (
  initialData: ShellUser | null = null,
  shouldFetchInit = true
): [ShellUser | null, UpdateUserFunction] => {
  const [shellUser, setShellUser] = useAtom(userAtom);
  const token = useLoginToken();

  const getUserData = useCallback(
    async (requestOption?: RequestInit) => {
      if (!token?.token) return null;
      const user = await getUser(token?.token, requestOption);
      if (user) {
        setShellUser(user);
      }
      return user;
    },
    [setShellUser, token?.token]
  );

  useEffect(() => {
    if (shouldFetchInit && !shellUser) {
      getUserData();
    }
  }, [getUserData, shellUser, shouldFetchInit]);

  return [shellUser ?? initialData, getUserData];
};
